<div class="row">
  <div class="col-sm-12">
    <section class="panel">
      <app-page-title title="List Introducers" [loading]="isLoading">
        {{ totalResults }} Results Found
      </app-page-title>

      <div class="panel-body">
        <table class="table table-striped">
          <thead>
          <tr>
            <th>Domain</th>
            <th>Introducer</th>
            <th>Product</th>
            <th>API Key</th>
            <th class="text-right">
              <a [routerLink]="['/introducers/create']" class="btn btn-success">Create</a>
            </th>
          </tr>
          </thead>

          <tbody>
          <tr *ngFor="let introducer of introducers">
            <td>{{ introducer?.domain?.name }}</td>
            <td>{{ introducer?.name }}</td>
            <td>{{ introducer?.product?.name }}</td>
            <td>{{ introducer?.apiKey }}</td>
            <td class="text-right">
              <div class="btn-group">
                <a [routerLink]="['/introducers', introducer?.id, 'edit']" type="button" class="btn btn-sm btn-warning">Edit</a>
                <button type="button" class="btn btn-sm btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <span class="caret"></span>
                  <span class="sr-only">Toggle Dropdown</span>
                </button>
                <ul class="dropdown-menu">
                  <li><a href="javascript:;" (click)="deleteModal.confirmDialog(introducer.id)">Delete</a></li>
                </ul>
              </div>
            </td>
          </tr>
          </tbody>

          <tfoot>
          <tr>
            <td colspan="99" class="text-center">
              <app-pagination [totalPages]="totalPages" [currentPage]="currentPage" (pageChanged)="onPageChanged($event)"></app-pagination>
            </td>
          </tr>
          </tfoot>
        </table>
      </div>
    </section>
  </div>
</div>

<app-delete-modal type="introducer" (confirm)="delete($event)" [itemDeleted]="introducerDeleted" #deleteModal></app-delete-modal>
